import ReactDOM from "react-dom";
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";

import Modal from "../common/Modal";
import ModalInnerWrapper from "../common/ModalInnerWrapper";
import PannelBody from "./PannelBody";
import { phoneFormat } from "../../lib/script";
import { formatPatientName } from "../../lib/patientName";
import TextareaBox from "../common/interactive/TextareaBox";
import Button from "../common/Button";
import { sendSMSApi } from "../../lib/fetchApi";
import { notificationActions } from "../../store/notifications";
import { getSmsTemplates } from "../../lib/systemData";

import classes from './SendSmsComponent.module.css'
import CustomSelect from "../common/interactive/CustomSelect";
import Backdrop from "../common/modal/Backdrop";

export default function SendSmsComponentBlank({children, phone, data, type}) {

    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [modalOpened, setModalOpened] = useState(false)

    const [templates, setTemplates] = useState(null)

    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [notesValue, setNotesValue] = useState(null)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    function openModal() {
        setModalOpened(true)
    }

    function closeModal() {
        setModalOpened(false)
    }


    async function sendSms(event) {
        event.preventDefault()
        setLoading(true)

        const fd = new FormData(event.target)

        const formData = Object.fromEntries(fd.entries())

        let reqBody = {
            phone: phone,
            sms: formData.sms_body
        }

        let sendMail = await sendSMSApi(userToken, activeCase.case.id, reqBody)
   
        if (sendMail && sendMail.errorMessage) {
            dispatch(notificationActions.setError(sendMail))
        } else {  

            dispatch(notificationActions.setError({errorMessage: sendMail.message, type: 'success'}))
        } 

        setModalOpened(false)
        setLoading(false)
    }

    function setTemplateHandler(value) {
        setSelectedTemplate(value.data.value)
        if (value.data.value && value.option.sms) {
            setNotesValue(value.option.sms)
        }
    }


    useEffect(() => {
        let templates = getSmsTemplates()

        if (templates && type) {


            let filteredTemplates = templates.filter(item => item.type == type)
            if (filteredTemplates) {
                setTemplates(filteredTemplates)
            } else {
                setTemplates(null)
            }
        }
    }, [])

    return <>
        <button onClick={openModal} className={classes.item_blank} title="Send SMS">
            {children}
        </button>
        {modalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModal} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModal} modalTitle={'Send SMS'}>
                        <PannelBody padding='large' background={'var(--line-transparent)'}>
                            <div className={classes.modal_header}>
                                <div>
                                    {/* <div className={classes.name_label}>Name</div> */}
                                    <div className={classes.name_label}>
                                        {type}
                                    </div>
                                    
                                    {data && <div className={classes.name}>
                                        {type == 'Patient' && <>{formatPatientName(data)}</>}
                                        {type == 'Attorney' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Case Manager' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Law Firm' && <>{data.name}</>}
                                        {type == 'Insurance Carrier' && <>{data.name}</>}
                                        {type == 'Adjuster' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Nurse' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Negotiator' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Representative' && <>{data.name}</>}
                                    </div>}
                                </div>
                                <div>
                                    <div className={classes.phone}>
                                        {phoneFormat(phone)}
                                    </div>
                                </div>
                            </div>
                        </PannelBody>
                        <PannelBody>
                            <CustomSelect label={'SMS Template'} optionsData={templates} action={setTemplateHandler} preSelectedValue={selectedTemplate}/>
                        </PannelBody>
                        <PannelBody>                            
                            <form onSubmit={sendSms}>
                                <div className={classes.row}>
                                    <TextareaBox label={'Notes'} name={'sms_body'} required={true} currentValue={notesValue}/>
                                </div>
                                <div className={classes.row}>
                                    <Button btnStyle={'full'} type={'submit'} isLoading={loading}>Submit</Button>
                                </div>
                            </form>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}